// import { Response, URLSearchParams } from '@angular/http';
// import { Injectable } from '@angular/core';
// import 'rxjs/add/operator/do';
// import 'rxjs/add/operator/catch';
// import 'rxjs/add/operator/share';
// import 'rxjs/add/operator/map';
// import { Observable } from 'rxjs/Observable';
// import {
//     DashboardSearchFilter,
//     EquipmentImplementDetails,
//     DashboardFavouriteImplementsCondition,
//     DashboardFavourites,
//     ImplementOverviewModel
// } from '../dashboard/dashboard.model';
// import {
//     GenericIdName, GenericIdNameImplementType
// } from '../setup-implement/setup-implement.model';
// import {
//     SearchFilters
// } from './search-panel/search-panel.model';
// import { HttpClient, HttpParams } from '@angular/common/http';

// @Injectable()
// export class GETDashboardService {
//     constructor(private _http: HttpClient) { }

//     private handleError(error: Response) {
//         console.error(error);
//         return Observable.throw(error.json().error || 'Server error');
//     }

//     public GetEquipmentForDashboardSearch(params: DashboardSearchFilter): Observable<EquipmentImplementDetails> {
//         return this._http.post('Api/GETDashboard/GetEquipmentForDashboardSearch', params).share().map(
//             (response: Response) => <EquipmentImplementDetails>response.json()).catch(this.handleError);
//     }

//     public GetEquipmentForDashboardFavourite(favouriteId: number): Observable<EquipmentImplementDetails> {
//         let options = {
//             params: new HttpParams().set('favouriteId', favouriteId.toString())
//         };
//         return this._http.get('Api/GETDashboard/GetEquipmentForDashboardFavourite', options).share().map(
//             (response: Response) => <EquipmentImplementDetails>response.json()).catch(this.handleError);
//     }

//     public GetImplementAvailableDashboard(searchFilters: DashboardSearchFilter, favouriteId: number): Observable<GenericIdNameImplementType[]> {
//         let options = {
//             params: new HttpParams().set('searchFilters', JSON.stringify(searchFilters))
//             .set('favouriteId', favouriteId.toString())
//         };
//         return this._http.get('Api/GETDashboard/GetImplementAvailableDashboard', options).share().map(
//             (response: Response) => <GenericIdNameImplementType[]>response.json()).catch(this.handleError);
//     }

//     public GetImplementTypesAvailable(searchFilters: DashboardSearchFilter, favouriteId: number): Observable<GenericIdName[]> {
//         let options = {
//             params: new HttpParams().set('searchFilters', JSON.stringify(searchFilters))
//             .set('favouriteId', favouriteId.toString())
//         };
//         return this._http.get('Api/GETDashboard/GetImplementTypesAvailable', options).share().map(
//             (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
//     }

//     public GetDashboardFavourites(): Observable<DashboardFavourites[]> {
//         return this._http.get('Api/GETDashboard/GetDashboardFavourites').share().map(
//             (response: Response) => <DashboardFavourites[]>response.json()).catch(this.handleError);
//     }

//     public GetImplementConditionForDashboard(favouriteId: number): Observable<DashboardFavouriteImplementsCondition> {
//         let options = {
//             params: new HttpParams()
//             .set('favouriteId', favouriteId.toString())
//         };
//         return this._http.get('Api/GETDashboard/GetImplementConditionForDashboard', options).share().map(
//             (response: Response) => <DashboardFavouriteImplementsCondition>response.json()).catch(this.handleError);
//     }

//     public PerformDashboardSearch(params: SearchFilters): Observable<DashboardFavouriteImplementsCondition> {
//         return this._http.post('Api/GETDashboard/PerformDashboardSearch', params).share().map(
//             (response: Response) => <DashboardFavouriteImplementsCondition>response.json()).catch(this.handleError);
//     }

   

//     public PerformDashboardSearchImplementOverview(params: SearchFilters): Observable<ImplementOverviewModel[]> {
//         return this._http.post('Api/GETDashboard/PerformDashboardSearch_Implement', params).share().map(
//             (response: Response) => <ImplementOverviewModel[]>response.json()).catch(this.handleError);
//     }

//     public PerformFavoriteSearchImplementOverview(searchFilters: SearchFilters, favouriteId: number): Observable<ImplementOverviewModel[]> {
//         let options = {
//             params: new HttpParams().set('searchFilters', JSON.stringify(searchFilters))
//             .set('favouriteId', favouriteId.toString())
//         };
//         return this._http.get('Api/GETDashboard/PerformFavouriteSearch_Implement', options).share().map(
//             (response: Response) => <ImplementOverviewModel[]>response.json()).catch(this.handleError);
//     }
    
//     public DeleteFavourite(favouriteId: number): Observable<boolean> {
//         let options = {
//             params: new HttpParams().set('favouriteId', favouriteId.toString())
//         };
//         return this._http.get('Api/GETDashboard/DeleteFavouriteById', options).share().map(
//             (response: Response) => <boolean>response.json()).catch(this.handleError);
//     }

//     public PerformDashboardSearchImplementLocationHistory(params: SearchFilters): Observable<ImplementOverviewModel[]> {
//         return this._http.post('Api/GETDashboard/PerformDashboardSearch_ImplementLocation', params).share().map(
//             (response: Response) => <ImplementOverviewModel[]>response.json()).catch(this.handleError);
//     }

// }



import { Injectable } from '@angular/core';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import {
    DashboardSearchFilter,
    EquipmentImplementDetails,
    DashboardFavouriteImplementsCondition,
    DashboardFavourites,
    ImplementOverviewModel,
    CrackHistory,
    CrackHistoryResponse
} from '../dashboard/dashboard.model';
import {
    GenericIdName, GenericIdNameImplementType
} from '../setup-implement/setup-implement.model';
import {
    SearchFilters
} from './search-panel/search-panel.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class GETDashboardService {
    constructor(private _http: HttpClient) { }

    private handleError(error: Response) {
        console.error(error);
        return Observable.throw(error || 'Server error');
    }

    public GetEquipmentForDashboardSearch(params: DashboardSearchFilter): Observable<EquipmentImplementDetails> {
        return this._http.post<EquipmentImplementDetails>('Api/GETDashboard/GetEquipmentForDashboardSearch', params).pipe(catchError(this.handleError));
        // return this._http.post('Api/GETDashboard/GetEquipmentForDashboardSearch', params).share().map(
        //     (response: Response) => <EquipmentImplementDetails>response.json()).catch(this.handleError);
    }

    public GetEquipmentForDashboardFavourite(favouriteId: number): Observable<EquipmentImplementDetails> {
        const options = {
            params: new HttpParams().set('favouriteId', favouriteId.toString())
          };
          return this._http.get<EquipmentImplementDetails>('Api/GETDashboard/GetEquipmentForDashboardFavourite', options).pipe(catchError(this.handleError));
        //   let params: URLSearchParams = new URLSearchParams();
        // params.set('favouriteId', favouriteId.toString());
        // return this._http.get('Api/GETDashboard/GetEquipmentForDashboardFavourite', { search: params }).share().map(
        //     (response: Response) => <EquipmentImplementDetails>response.json()).catch(this.handleError);
    }

    // public GetImplementAvailableDashboard(searchFilters: DashboardSearchFilter, favouriteId: number): Observable<GenericIdNameImplementType[]> {
    //     const options = {
    //         params: new HttpParams().set('searchFilters', searchFilters.toString())
    //         .set('favouriteId', favouriteId.toString())
    //       };
    //       return this._http.get<GenericIdNameImplementType[]>('Api/GETDashboard/GetImplementAvailableDashboard', options).pipe(catchError(this.handleError));
    //     // let params = { searchFilters: searchFilters, favouriteId: favouriteId };
    //     // return this._http.get('Api/GETDashboard/GetImplementAvailableDashboard', { search: params }).share().map(
    //     //     (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
    // }
    public GetImplementAvailableDashboard(searchFilters: DashboardSearchFilter, favouriteId: number): Observable<GenericIdNameImplementType[]> {
        debugger;
        const params = new HttpParams()
         .set('searchFilters', JSON.stringify(searchFilters))
         .set('favouriteId', favouriteId.toString());
      
        return this._http.get<GenericIdNameImplementType[]>('Api/GETDashboard/GetImplementAvailableDashboard', { params })
         .pipe(catchError(this.handleError));
      }
    

    public GetImplementTypesAvailable(searchFilters: DashboardSearchFilter, favouriteId: number): Observable<GenericIdName[]> {
        const options = {
            params: new HttpParams().set('searchFilters', searchFilters.toString())
            .set('favouriteId', favouriteId.toString())
          };
          return this._http.get<GenericIdName[]>('Api/GETDashboard/GetImplementTypesAvailable', options).pipe(catchError(this.handleError));
        // let params = { searchFilters: searchFilters, favouriteId: favouriteId };
        // return this._http.get('Api/GETDashboard/GetImplementTypesAvailable', { search: params }).share().map(
        //     (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
    }

    public GetDashboardFavourites(): Observable<DashboardFavourites[]> {
          return this._http.get<DashboardFavourites[]>('Api/GETDashboard/GetDashboardFavourites').pipe(catchError(this.handleError));
        // return this._http.get('Api/GETDashboard/GetDashboardFavourites').share().map(
        //     (response: Response) => <DashboardFavourites[]>response.json()).catch(this.handleError);
    }

    public GetImplementConditionForDashboard(favouriteId: number): Observable<DashboardFavouriteImplementsCondition> {
        const options = {
            params: new HttpParams()
            .set('favouriteId', favouriteId.toString())
          };
          return this._http.get<DashboardFavouriteImplementsCondition>('Api/GETDashboard/GetImplementConditionForDashboard', options).pipe(catchError(this.handleError));
        // let params: URLSearchParams = new URLSearchParams();
        // params.set('favouriteId', favouriteId.toString());
        // return this._http.get('Api/GETDashboard/GetImplementConditionForDashboard', { search: params }).share().map(
        //     (response: Response) => <DashboardFavouriteImplementsCondition>response.json()).catch(this.handleError);
    }

    public PerformDashboardSearch(params: SearchFilters): Observable<DashboardFavouriteImplementsCondition> {
        return this._http.post<DashboardFavouriteImplementsCondition>('Api/GETDashboard/GetImplementConditionForDashboard', params).pipe(catchError(this.handleError));
        // return this._http.post('Api/GETDashboard/PerformDashboardSearch', params).share().map(
        //     (response: Response) => <DashboardFavouriteImplementsCondition>response.json()).catch(this.handleError);
    }

    public PerformDashboardSearchImplementOverview(params: SearchFilters): Observable<ImplementOverviewModel[]> {
        return this._http.post<ImplementOverviewModel[]>('Api/GETDashboard/PerformDashboardSearch_Implement', params).pipe(catchError(this.handleError));
        // return this._http.post('Api/GETDashboard/PerformDashboardSearch_Implement', params).share().map(
        //     (response: Response) => <ImplementOverviewModel[]>response.json()).catch(this.handleError);
    }

    public PerformFavoriteSearchImplementOverview(searchFilters: SearchFilters, favouriteId: number): Observable<ImplementOverviewModel[]> {
        const options = {
            params: new HttpParams()
            .set('searchFilters', JSON.stringify(searchFilters))
            .set('favouriteId', favouriteId.toString())
          };
          return this._http.get<ImplementOverviewModel[]>('Api/GETDashboard/PerformFavouriteSearch_Implement', options).pipe(catchError(this.handleError));
        // let params = { searchFilters: searchFilters, favouriteId: favouriteId };
        // console.log("paaaaa", params)
        // return this._http.get('Api/GETDashboard/PerformFavouriteSearch_Implement', { search: params }).share().map(
        //     (response: Response) => <ImplementOverviewModel[]>response.json()).catch(this.handleError);
    }
    

    public DeleteFavourite(favouriteId: number): Observable<boolean> {
        const options = {
            params: new HttpParams()
            .set('favouriteId', favouriteId.toString())
          };
          return this._http.get<boolean>('Api/GETDashboard/DeleteFavouriteById', options).pipe(catchError(this.handleError));
        // let params: URLSearchParams = new URLSearchParams();
        // params.set('favouriteId', favouriteId.toString());
        // return this._http.get('Api/GETDashboard/DeleteFavouriteById', { search: params }).share().map(
        //     (response: Response) => <boolean>response.json()).catch(this.handleError);
    }

    public PerformDashboardSearchImplementLocationHistory(params: SearchFilters): Observable<ImplementOverviewModel[]> {
        return this._http.post<ImplementOverviewModel[]>('Api/GETDashboard/PerformDashboardSearch_ImplementLocation', params).pipe(catchError(this.handleError));
        // return this._http.post('Api/GETDashboard/PerformDashboardSearch_ImplementLocation', params).share().map(
        //     (response: Response) => <ImplementOverviewModel[]>response.json()).catch(this.handleError);
    }

    public GetCrackView(params: SearchFilters): Observable<CrackHistoryResponse> {
        return this._http.post<CrackHistoryResponse>('Api/GETDashboard/GetCrackView', params).pipe(catchError(this.handleError));
    }

    public GetCrackExcelView(params: SearchFilters): Observable<CrackHistoryResponse> {
        return this._http.post<CrackHistoryResponse>('Api/GETDashboard/GetCrackExcelData', params).pipe(catchError(this.handleError));
    }

    public saveCrackPreferences(payload: any) {
      return this._http.post('/Api/GETDashboard/SaveCrackViewPreferences', payload).pipe(catchError(this.handleError));
    }
}